export const USPS_LIST = {
    jetta: [
    {
      title: 'Стильные светодиодные фары',
      text: 'Полностью светодиодная оптика: ближний и дальний свет фар, а также дневные ходовые огни работают на светодиодах.',
      pointName: 'lights',
      gaLabel: 'uspLedLightsPoint'
    },
    {
      title: 'Адаптивный круиз-контроль',
      text: 'Адаптивный круиз-контроль помогает следовать за впереди идущим автомобилем на заданной дистанции. Если его скорость изменится, ваша Jetta соответственно снизит или повысит скорость*.',
      subText: '* Адаптивный круиз-контроль и система Front Assist имеют ограничения в работе. Перед использованием ознакомьтесь с руководством по эксплуатации.',
      pointName: 'adaptive-cruise',
      gaLabel: 'uspCruisCntrlPoint'
    },
    {
      title: 'Система контроля дистанции Front Assist',
      text: 'Радарные датчики определяют расстояние до автомобиля, идущего впереди. А также предупреждают вас об опасности столкновения при сокращении дистанции.\n' +
        'Если водитель не реагирует, система может автоматически задействовать тормоз*.',
      subText: '* Адаптивный круиз-контроль и система Front Assist имеют ограничения в работе. Перед использованием ознакомьтесь с руководством по эксплуатации.',
      pointName: 'distation-system',
      gaLabel: 'uspFrontAssistPoint'
    },
    {
      title: 'Система бесключевого доступа и запуска двигателя Kessy',
      text: 'Больше не нужно доставать ключ. Просто откройте дверь и нажмите кнопку, чтобы запустить двигатель. Все это благодаря системе бесключевого доступа и запуска двигателя Kessy.',
      pointName: 'door',
      gaLabel: 'uspKessyPoint'
    },
    {
      title: 'Камера заднего вида',
      text: 'Новая Jetta оборудована камерой заднего вида для помощи при парковке.',
      pointName: 'trunk',
      gaLabel: 'uspBackCameraPoint'
    },
    {
      title: 'Панорамная крыша',
      text: 'Панорамный люк с приводом подъема / открывания сделает поездку в солнечный день незабываемой для всех.',
      pointName: 'roof',
      gaLabel: 'uspPanaramicRoofPoint'
    },
    {
      title: 'Подогрев руля и сидений',
      text: 'Зимой будет всегда тепло не только вам, но и всем пассажирам. Руль, передние и задние сиденья оснащены подогревом. Как передние, так и задние сиденья оснащаются подогревом подушки и спинки кресла.',
      pointName: 'wheel-seats',
      gaLabel: 'uspSeatAndWeelHeatPoint'
    },
    {
      title: 'Цифровая приборная панель',
      text: 'Цифровую приборную панель легко настраивать под себя, чтобы всё самое важное и нужное всегда было перед глазами. Вы можете настраивать размер и вид приборов, а также выбирать параметры, которые будут интересны и полезны именно вам.',
      pointName: 'hud',
      gaLabel: 'uspDigitalPanelPoint'
    },
    {
      title: 'App-Connect и навигация',
      text: 'Слушайте музыку, следите за маршрутом и управляйте программами на интерактивном экране с помощью смартфона, поддерживающего Apple CarPlayTM, Android AutoTM.\n' +
        'Также для выбора оптимального маршрута вы можете воспользоваться навигационной системой Volkswagen.',
      pointName: 'app-connect',
      gaLabel: 'uspAppConnectPoint'
    },
    {
      title: 'Просторный и удобный салон',
      text: 'В новой Jetta каждый элемент салона\n' +
        'продуман для удобства водителя. Поэтому не удивляйтесь, если вам захочется, чтобы поездка не кончалась.',
      pointName: 'interior',
      gaLabel: 'uspComfortableInteriorPoint'
    },
    {
      title: 'Атмосферная подсветка салона',
      text: 'Для Jetta предлагается десять вариантов атмосферной подсветки салона. Выбирайте цвет под настроение — или меняйте настроение с помощью цвета.',
      pointName: 'ambient-light',
      gaLabel: 'uspAtmosphLightPoint'
    },
  ],
  polo: [
    {
      title: 'Светодиодные фары',
      text: 'Светодиодные фары проекционного типа с функцией всепогодного освещения.',
      pointName: 'lights',
      gaLabel: 'uspLedLightPoint'
    },
    {
      title: 'Передние и задние датчики парковки',
      text: 'Делают парковку безопасной и лёгкой.',
      pointName: 'parking',
      gaLabel: 'uspParkingSensorsPoint'
    },
    {
      title: 'Задние светодиодные фонари',
      text: 'Новые задние фонари имеют объёмную трёхмерную форму, что делает рисунок их свечения наиболее эффективным.',
      pointName: 'back-lights',
      gaLabel: 'uspBackLightsPoint'
    },
    {
      title: 'Камера заднего вида',
      text: 'Мы подумали обо всём. И даже о том, чтобы на камеру заднего вида не попадала грязь. Именно поэтому мы выбрали для неё уникальное расположение — под логотипом на крышке багажника.',
      pointName: 'camera',
      gaLabel: 'uspBackCameraPoint'
    },
    {
      title: 'Откройте пространство заново',
      text: 'Объем багажника составляет внушительные 530 литров, а с учетом возможности трансформации салона, грузовое пространство можно увеличить вплоть до 1460 литров!',
      pointName: 'trunk',
      gaLabel: 'uspTrunkPoint'
    },
    {
      title: 'Kessy',
      text: 'Система бесключевого доступа и запуска двигателя позволяет открывать двери прикосновением к ручкам, не доставая ключи, и заводить двигатель нажатием кнопки.',
      pointName: 'door',
      gaLabel: 'uspKessyPoint'
    },
    {
      title: 'Датчики света, дождя и зеркало с автозатемнением',
      text: 'Каждая из этих функций работает на то, чтобы любая поездка стала максимально комфортной.',
      pointName: 'light-sensors',
      gaLabel: 'uspLightSensorsPoint'
    },
    {
      title: 'Цифровая приборная панель',
      text: 'Цифровую приборную панель легко настраивать под себя, чтобы всё самое важное и нужное всегда было перед глазами. Вы можете настраивать размер и вид приборов, а также выбирать параметры, которые будут интересны и полезны именно вам.',
      pointName: 'hud',
      gaLabel: 'USPDigitalPanelpoint'
    },
    {
      title: 'Откройте тепло заново',
      text: 'Зимой будет всегда тепло не только вам, но и всем пассажирам. Подогрев лобового стекла. Руль, передние и задние сиденья оснащены подогревом.',
      pointName: 'interior',
      gaLabel: 'USPHeatPoint'
    },
    {
      title: 'App-Connect',
      text: 'App-Connect позволяет подключать смартфон к информационно- развлекательной системе автомобиля и в дальнейшем управлять приложениями, поддерживающими стандарты подключения Apple CarPlayTM и Google Android AutoTM.',
      pointName: 'multimedia',
      gaLabel: 'USPAppConnectPoint'
    }
  ]
}